module.exports = __webpack_public_path__ + "static/media/value-proposition-match-ai@3x.06d36838.png";